import DynamicSectionElement from "../../frontend/scripts/dynamic-section-element"

class RecommendedProducts extends DynamicSectionElement {
  constructor () {
    super()
    this.sectionId = this.dataset.sectionId

    let showSection = false
    const userInteractionEvents = ["scroll", "mousedown", "mousemove", "click", "keydown", "touchstart"]
    userInteractionEvents.forEach( event => {
      window.addEventListener(event, () => {
        if (!showSection) {
          showSection = true
          this.loadSectionFromUrl(window.location.pathname + '?view=ajax')
        }
      }, { passive: true })
    })

    if (document.body.getBoundingClientRect() && (document.body.getBoundingClientRect().y !== 0) ) {
      showSection = true
      this.loadSectionFromUrl(window.location.pathname + '?view=ajax')
    }
  }

  get name () {
    return this.sectionId
  }
}

if (!customElements.get('recommended-products')) {
    customElements.define('recommended-products', RecommendedProducts)
}

